import { render } from "./AssessmentDropdown.vue?vue&type=template&id=99247da8"
import script from "./AssessmentDropdown.vue?vue&type=script&lang=js"
export * from "./AssessmentDropdown.vue?vue&type=script&lang=js"

import "./AssessmentDropdown.vue?vue&type=style&index=0&id=99247da8&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__